import { render, staticRenderFns } from "./IndividualStudentMessages.vue?vue&type=template&id=7ac8ac8a&scoped=true"
import script from "./IndividualStudentMessages.vue?vue&type=script&lang=js"
export * from "./IndividualStudentMessages.vue?vue&type=script&lang=js"
import style0 from "./IndividualStudentMessages.vue?vue&type=style&index=0&id=7ac8ac8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac8ac8a",
  null
  
)

export default component.exports